export default "__VITE_ASSET__fb31af6d__"